/**
 * LayoutContentArea Component
 * Consistently styled page layout with optional page heading
 */

export default function LayoutContentArea({
  headingText,
  headerActions,
  children,
  noBorder = false,
  showHeadingSection = true,  
}: {
  headingText?: string | React.ReactNode;
  headerActions?: React.ReactNode;
  children: React.ReactNode;
  noBorder?: boolean;
  showHeadingSection?: boolean; 
}) {
  return (
    <>
      {/* Page Heading (shown by default, but can be turned off) */}
      {showHeadingSection && (
        <div className="px-4 pt-3">
          <div className="mt-3 pb-2 d-flex justify-content-between align-items-center">
            {typeof headingText === "string" ? (
              <h1 className="fs-4 mb-0" style={{ lineHeight: "2.5rem" }}>
                {headingText}
              </h1>
            ) : (
              headingText
            )}

            {headerActions}
          </div>
        </div>
      )}

      {/* Page Content */}
      <div className="p-4">{children}</div>
    </>
  );
}
